<template>
  <FooterColumn
    :title="mgnlProps.title"
    :links="mgnlProps.link"
    :show-column-kiosk="mgnlProps.showColumnKiosk"
    :show-column-catalog="mgnlProps.showColumnCatalog"
  />
</template>

<script lang="ts" setup>
import FooterColumn from '~/components/Footer/FooterColumn/FooterColumn.vue';
import { FooterColumnBuilder, WrapperProps } from '~/components/Footer/FooterColumn/FooterColumn.model';

const props = defineProps(WrapperProps);
const mgnlProps = FooterColumnBuilder.build(props);
</script>
